<template>
  <div class="logo-section">
    <svg viewBox="0 0 120 100" fill="none" xmlns="http://www.w3.org/2000/svg" class="welcome-logo">
      <path d="M 20 52 Q 15 60 15 70 L 25 70 Q 25 58 28 52 Z" fill="currentColor"></path>
      <rect x="28" y="28" width="38" height="25" fill="currentColor"></rect>
      <path d="M 26 29 L 26 18 L 68 18 L 68 29 Z" fill="currentColor"></path>
      <rect x="32" y="22" width="14" height="8" fill="#0E1621" opacity="0.5"></rect>
      <rect x="50" y="22" width="14" height="8" fill="#0E1621" opacity="0.5"></rect>
      <rect x="64" y="8" width="3" height="10" rx="1" fill="currentColor"></rect>
      <ellipse cx="65.5" cy="8" rx="4" ry="2" fill="currentColor"></ellipse>
      <path
        d="M 66 42 L 85 42 Q 95 42 100 48 L 105 55 Q 108 58 108 62 L 108 68 L 77 68 Q 72 68 68 64 Q 66 62 66 58 Q 66 56 66 53 Z"
        fill="currentColor"
      ></path>
      <line x1="86" y1="48" x2="90" y2="52" stroke="#0E1621" stroke-width="1" opacity="0.3"></line>
      <line x1="90" y1="48" x2="94" y2="52" stroke="#0E1621" stroke-width="1" opacity="0.3"></line>
      <line x1="94" y1="48" x2="98" y2="52" stroke="#0E1621" stroke-width="1" opacity="0.3"></line>
      <path
        d="M 66 42 Q 67 36 68 32"
        stroke="currentColor"
        stroke-width="4"
        fill="none"
        stroke-linecap="round"
      ></path>
      <path
        d="M 66 53 Q 67 48 68 45"
        stroke="currentColor"
        stroke-width="4"
        fill="none"
        stroke-linecap="round"
      ></path>
      <g class="wheel-spin">
        <circle cx="35" cy="70" r="22" fill="currentColor"></circle>
        <circle cx="35" cy="70" r="14" fill="#229ed9"></circle>
        <circle cx="35" cy="70" r="6" fill="currentColor"></circle>
      </g>
      <g class="wheel-spin-small">
        <circle cx="90" cy="79" r="13" fill="currentColor"></circle>
        <circle cx="90" cy="79" r="8" fill="#229ed9"></circle>
        <circle cx="90" cy="79" r="4" fill="currentColor"></circle>
      </g>
    </svg>
    <h1 v-if="titlePrefix || appName" class="welcome-title">
      <span v-if="titlePrefix" class="welcome-title-prefix">{{ titlePrefix }}</span>
      <span class="app-name-gradient">{{ appName }}</span>
    </h1>
    <p v-if="subtitle" class="welcome-subtitle">{{ subtitle }}</p>
  </div>
</template>

<script setup>
defineProps({
  titlePrefix: {
    type: String,
    default: '',
  },
  appName: {
    type: String,
    default: 'Tracktor',
  },
  subtitle: {
    type: String,
    default: '',
  },
})
</script>

<style scoped>
.logo-section {
  text-align: center;
  padding: 48px 24px 32px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.welcome-logo {
  width: 120px;
  height: 100px;
  margin-bottom: 24px;
  color: white;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));
}

.wheel-spin,
.wheel-spin-small {
  animation: spin 3s linear infinite;
  transform-origin: center;
}

.wheel-spin {
  transform-origin: 35px 70px;
}

.wheel-spin-small {
  transform-origin: 90px 79px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.welcome-title {
  font-size: 32px;
  font-weight: 700;
  margin: 0 0 8px;
  color: white;
}

.welcome-title-prefix {
  margin-right: 0.25em;
}

.app-name-gradient {
  background: linear-gradient(135deg, #2aabee, #229ed9);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 800;
}

.welcome-subtitle {
  font-size: 16px;
  margin: 0;
  opacity: 0.95;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
}

@media (max-width: 640px) {
  .logo-section {
    padding: 32px 20px 24px;
  }

  .welcome-logo {
    width: 90px;
    height: 75px;
  }

  .welcome-title {
    font-size: 24px;
  }

  .welcome-subtitle {
    font-size: 14px;
  }
}
</style>
